module.exports = __webpack_public_path__ + "img/alert-icon-success.ae5a871c.svg";